// extracted by mini-css-extract-plugin
export default {"arrowIcon":"z3SJ3E","arrowWrapper":"c4iU97","arrow":"Cg44ot"};